module.exports = __webpack_public_path__ + "static/media/auroraBorealis.2271afcb.jpg";